export default __webpack_public_path__ + "static/media/insta.cb931feb.svg";